import RichText from "@/components/RichText";

const FALLBACK_BLOCKS = [
  { id: "fallback-1", props: { image_url: "", caption: "", alt: "" } },
  { id: "fallback-2", props: { image_url: "", caption: "", alt: "" } },
  { id: "fallback-3", props: { image_url: "", caption: "", alt: "" } },
  { id: "fallback-4", props: { image_url: "", caption: "", alt: "" } },
  { id: "fallback-5", props: { image_url: "", caption: "", alt: "" } },
  { id: "fallback-6", props: { image_url: "", caption: "", alt: "" } },
];

const DEFAULTS = { eyebrow: "", heading: "Galerie", subheading: "", columns: "3", variant: "light", anchor_id: "" };

const COLS = {
  "2": "sm:grid-cols-2",
  "3": "sm:grid-cols-2 lg:grid-cols-3",
  "4": "sm:grid-cols-2 lg:grid-cols-4",
};

export default function GallerySection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const items = (blocks === undefined ? FALLBACK_BLOCKS : blocks).filter((b) => b.enabled !== false);
  const dark = t.variant === "dark";
  if (!items.length && !t.heading) return null;
  const colClass = COLS[t.columns] || COLS["3"];

  return (
    <section
      id={t.anchor_id || undefined}
      data-testid="gallery-section"
      className={`scroll-mt-28 ${dark ? "bg-ink" : ""}`}
    >
      <div className="max-w-[1240px] mx-auto px-6 md:px-10 py-20 md:py-28 scroll-mt-28">
        {(t.eyebrow || t.heading || t.subheading) && (
          <div className="text-center max-w-2xl mx-auto mb-12">
            {t.eyebrow && (
              <RichText
                as="span"
                className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-[12px] font-semibold tracking-wide uppercase mb-4 ${
                  dark ? "border-white/15 bg-white/5 text-gold" : "border-stone bg-sand text-gold"
                }`}
                html={t.eyebrow}
              />
            )}
            {t.heading && (
              <RichText
                as="h2"
                className={`font-display font-semibold text-[30px] md:text-[34px] leading-tight tracking-[-0.02em] ${dark ? "text-white" : "text-ink"}`}
                html={t.heading}
              />
            )}
            {t.subheading && (
              <RichText as="p" preserveParagraphs className={`text-[16px] mt-4 ${dark ? "text-white/60" : "text-graphite"}`} html={t.subheading} />
            )}
          </div>
        )}

        <div className={`grid grid-cols-2 ${colClass} gap-3 md:gap-4`}>
          {items.map((block, i) => {
            const url = (block.props?.image_url || "").trim();
            const caption = block.props?.caption;
            return (
              <figure
                key={block.id}
                data-block-key={block.id}
                className="group relative overflow-hidden rounded-2xl bg-sand animate-fade-up"
                style={{ animationDelay: `${i * 50}ms` }}
              >
                <div className="aspect-square w-full">
                  {url ? (
                    <img
                      src={url}
                      alt={block.props?.alt || ""}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                  ) : (
                    <div className="h-full w-full flex items-center justify-center text-ash text-[12px]">Image</div>
                  )}
                </div>
                {caption && (
                  <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                    <RichText as="span" className="text-white text-[13px] font-medium" html={caption} />
                  </figcaption>
                )}
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}
